import {
  Box,
  Link,
  Typography,
  CardHeader,
  FormGroup,
  Divider,
  Tooltip,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Button from "@mui/material/Button";
import { CustomCheckBox } from "../utils/CustomCheckBox";
import { useState } from "react";

interface filterObj {
  id: string;
  name: string;
}

interface moduleCardProps {
  filters: string[];
  close: () => void;
  availableFilters: filterObj[];
  onFilterSubmit: (filterString: string) => void;
}

export const VideoFilterModal = (props: moduleCardProps) => {
  const [selectedFilters, setSelectedFilters] = useState<string[]>(props.filters);
  return (
    <>
      <CardHeader
        sx={{ padding: "16px 24px" }}
        title={
          <Typography
            id="filter-modal-title"
            variant="h6"
            sx={{ color: "#000000", fontWeight: "bold", fontSize: "20px" }}>
            Filter videos
          </Typography>
        }
        action={
          <Tooltip title="Close" arrow role="tooltip" describeChild>
            <IconButton
              onClick={props.close}
              aria-label="close filter"
              sx={{ color: "#000000" }}>
              <CloseIcon />
            </IconButton>
          </Tooltip>
        }
      />
      <Divider />
      <CardContent sx={{ padding: "32px" }}>
        <Typography
          variant="h6"
          sx={{ color: "#000000", fontWeight: "bold", fontSize: "24px" }}>
          Filter videos
        </Typography>
        <FormGroup sx={{ display: "grid", gridTemplateColumns: "50% 50%" }}>
          {props.availableFilters.map((filter) => {
            return (
              <CustomCheckBox
                key={`filteroption-${filter.id}`}
                label={filter.name}
                checked={selectedFilters.includes(filter.id)}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedFilters([...selectedFilters, filter.id]);
                  } else {
                    setSelectedFilters(selectedFilters.filter((f) => f !== filter.id));
                  }
                }}
                emitDataLayer={(checked) => {}}
              />
            );
          })}
        </FormGroup>
      </CardContent>
      <Divider />
      <CardActions sx={{ padding: "24px 48px" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}>
          <Link
            onClick={() => {
              props.close();
              props.onFilterSubmit("");
            }}
            href="#"
            variant="body1">
            Clear all
          </Link>
          <Link
            onClick={() => {
              props.onFilterSubmit(selectedFilters.join(","));
              props.close();
            }}
            href="#"
            underline="none">
            <Button
              size="large"
              variant="contained"
              sx={{
                borderRadius: "16px",
                width: "180px",
                height: "62px",
                padding: "0px",
              }}>
              Show results
            </Button>
          </Link>
        </Box>
      </CardActions>
    </>
  );
};
